import {
  CHAT_OPEN,
  RESET_CHAT,
  RESET_MESSAGE_STATUS,
  SET_CHANNEL,
  SET_CHANNEL_HISTORY,
  SET_CONNECTION,
} from "../actions/actionsTypes";

const initialState = {
  channel: {
    channelId: 0,
    name: "",
    createdAt: "",
    nonParticipantProfileId: "",
    moderator: null,
    roleId: 0,
    role: null,
    participants: [],
  },
  channelHistory: [],
  channelConnection: null,
  chatOpen: false,
  connection: null,
};

export const chatReducer = (state = initialState, action) => {
  if (action.type === SET_CHANNEL) {
    return {
      ...state,
      channel: action.payload,
    };
  }
  if (action.type === SET_CHANNEL_HISTORY) {
    return {
      ...state,
      channelHistory: action.payload,
    };
  }
  if (action.type === RESET_MESSAGE_STATUS) {
    const newStatus = state.channelHistory?.map((e) => ({
      ...e,
      isRead: true,
    }));
    return {
      ...state,
      channelHistory: newStatus,
    };
  }
  if (action.type === RESET_CHAT) {
    return {
      channel: {
        channelId: 0,
        name: "",
        createdAt: "",
        nonParticipantProfileId: "",
        moderator: null,
        roleId: 0,
        role: null,
        participants: [],
      },
      channelHistory: [],
      chatOpen: false,
      connection: null,
    };
  }
  if (action.type === SET_CONNECTION) {
    return {
      ...state,
      connection: action.payload,
    };
  }
  if (action.type === CHAT_OPEN) {
    return {
      ...state,
      chatOpen: action.payload,
    };
  }
  return state;
};
